import gsap from 'gsap';
import { getCurrentDevice } from '../utils';

export class PostCover {
	constructor( selector, options = {} ) {
		this.elements = document.querySelectorAll( selector );
		this.options = options;
		this.devices = options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ];
		this.currentDevice = getCurrentDevice();
		this.enterFuncs = [];
		this.leaveFuncs = [];
		this.timelines = [];
		this.init();
	}
	init() {
		if ( this._initBound ) return;
		this._initBound = true;
		if ( ! this.elements?.length || ! this.devices.length ) return;
		window.addEventListener( 'DOMContentLoaded', () => {
			if ( this.devices.includes( this.currentDevice ) ) {
				this.execute();
			}
		} );
	}

	execute() {
		this.elements.forEach( ( container, index ) => {
			const items = gsap.utils.toArray( '.el-cover-item', container );
			if ( items.length < 2 ) return;
			const theToggle = this.options.onToggle;
			if ( theToggle === 'hover' ) {
				this.enterFuncs[ index ] = () => this.enter( index, items );
				this.leaveFuncs[ index ] = () => this.leave( index, items );
				container.addEventListener(
					'mouseenter',
					this.enterFuncs[ index ]
				);
				container.addEventListener(
					'mouseleave',
					this.leaveFuncs[ index ]
				);
			} else {
				this.enter( index, items );
			}
		} );
	}

	enter( index, items ) {
		if ( this.options.ignoreFirst ) {
			gsap.set( items[ 0 ], { opacity: 0 } );
			if ( items.length < 3 ) {
				gsap.set( items[ 1 ], { opacity: 1 } );
				return;
			}
		}
		const stay = this.options.stay || 0.3;
		const label = `+=${ stay }`;
		const tl = gsap.timeline( {
			paused: true,
			repeat: -1,
			repeatDelay: stay,
		} );
		items.forEach( ( item, i ) => {
			if ( this.options.ignoreFirst && i === 0 ) return;
			if ( this.options.ignoreFirst && i - 1 > 0 ) {
				tl.set( items[ i - 1 ], { opacity: 0 }, label );
			} else if ( i - 1 > -1 ) {
				tl.set( items[ i - 1 ], { opacity: 0 }, label );
			}
			tl.set( item, { opacity: 1 }, '<' );
		} );
		tl.play();
		this.timelines[ index ] = tl;
	}

	leave( index, items ) {
		this.timelines[ index ]?.kill();
		this.timelines[ index ] = null;
		gsap.set( items, { clearProps: 'opacity' } );
	}
}
